import type { Module } from '@efdigital/ll-addon-data';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { set } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { type Store } from '@warp-drive/core';

import { type EditRecordSignature } from '../edit-record.gts';
import { EditRecord } from '../edit-record.gts';
import ImageEditor from '../pickers/image-picker.gts';

export class EditModuleContent extends Component<EditRecordSignature<Module>> {
  @service declare store: Store;

  setValue = (property: string, event: Event) => {
    const target = event.target as HTMLInputElement;
    set(this.args.item, property, target.value);
  };

  setMarkdown = (markdown: string) => {
    set(this.args.item, 'markdown', markdown);
  };

  handleIconChange = (value: string) => {
    set(this.args.item, 'icon', value);
  };

  <template>
    <EditRecord
      @editLabel="Edit Content"
      @item={{@item}}
      @context={{@context}}
      ...attributes
    >
      <:form as |uniqueId isDisabled|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          <legend class="gud-eyebrow">Content</legend>

          <div class="form-group mb-3">
            <label
              for="{{uniqueId}}-title"
              class="form-control-label required"
            >Title</label>
            <input
              type="text"
              class="form-control"
              id="{{uniqueId}}-title"
              value={{@item.title}}
              required
              {{on "change" (fn this.setValue "title")}}
            />
          </div>

          <div class="form-group mb-3">
            <label
              for="{{uniqueId}}-icon"
              class="form-control-label"
            >Image</label>
            <ImageEditor
              @value={{@item.icon}}
              @onChange={{this.handleIconChange}}
              @sizeHint="module-icon"
              @defaultTitle={{@item.title}}
              @readonly={{isDisabled}}
              @id="{{uniqueId}}-icon"
              @placeholder="https://"
            />
          </div>
        </fieldset>
      </:form>
    </EditRecord>
  </template>
}
